module.exports = __webpack_public_path__ + "static/img/Arcane_Logo_Full.4541e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/launch/Arcane_Logo_Full.png
// module id = S7sj
// module chunks = 1